import React from "react";
import Reflux from "reflux";
import axios from 'axios';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Card, Container, Row, CardBody, Label, FormGroup, Input, Form, Col, Button, ButtonGroup, Modal, CardHeader, Collapse, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import LoadingOverlay from "react-loading-overlay";
// core components
import Header from "../../components/Headers/Header";
import { withRouter } from 'react-router-dom';
import moment from "moment";
// JavaScript library that creates a callendar with events
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import uuid from "react-uuid";
// react component used to create sweet alerts
import { UserStore } from "../../store/UserStore";
import { removeToken } from "../../utils";
import esLocale from '@fullcalendar/core/locales/es'
import "@fullcalendar/timegrid/main.css";
import "../../assets/vendor/fullcalendar/dist/fullcalendar.min.css";
import "../../assets/vendor/sweetalert2/dist/sweetalert2.min.css";
var DatePicker = require("reactstrap-date-picker");
const spanishDayLabels = ['Dom', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sab'];
const spanishMonthLabels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

let calendar;

class planificacionTareas extends Reflux.Component<any, any> {
    public maxFileSize = 3;
    public fileInput: any = null;
    public lecturasRef: any = [];
    public inputEl: any = null;
    public formRef: any = null;
    lastFilters = {};
    state = {
        filters: {
            empresa: "",
            eventoDesde: "",
            eventoHasta: "",
            municipio: ""
        },
        UserStore: {},
        isLoading: false,
        copiedText: null,
        currentPage: 0,
        pageSize: 0,
        pageCount: 0,
        count: 0,
        contrato: "",
        tipocliente: "",
        idCliente: '',
        companyIdUser: '',
        companyNameGlobal: '',
        userGroupId: 1000,
        userId: '',
        saveDataCliente: false,
        updateDataCliente: false,
        saveClienteButtonDisabled: true,
        updateClienteButtonDisabled: true,
        saveXMLButtonDisabled: true,
        buscarButtonDisabled: true,
        show: false,
        facturaButtonDisabled: true,
        showFilters: true,
        toggledClearRows: false,
        locale: 'es',
        inputIdDisabled: true,
        inputDisabled: true,
        municipios: [{ id: "", valor: 0 }],
        empresas: [{ id: "", valor: 0 }],
        alert: null,
        codigoIneEvento: null,
        municipioEvento: null,
        nifEvento: null,
        empresaEvento: null,
        municipioEventoDescripcion: null,
        comercializadoraEventoDescripcion: null,
        fechaDesdeEvento: null,
        fechaHastaEvento: null,
        eventoDesde: "",
        eventoHasta: "",
        events: [{
            title: null,
            start: null,
            end: null,
            className: null,
            id: null,
            description: null
        }],
    };

    constructor(props) {
        super(props);
        this.store = UserStore;
        this.logout = this.logout.bind(this);
        this.formRef = React.createRef();
        this.confirmAlertExit = this.confirmAlertExit.bind(this);
    };

    componentDidMount() {
        const user = localStorage.getItem("user");
        this.getEmpresaLista();
        this.getUserData();
        this.getcalendarioList()
        if (user) {
            const parsed = JSON.parse(user);
            this.setState({
                user: parsed
            });
        };
        this.setState({
            ...this.state,
        });
    };

    ////////////////////////////////////////////////////////////////////////////////////////

    getUserData() {
        const userID = localStorage.getItem("uuidUser")
        const token = localStorage.getItem("token")
        var user: any = [];
        var dataFilters = {
            'userId': userID
        }
        const valores = JSON.stringify(dataFilters)
        const headers = {
            
            'Content-Type': 'application/json',
        };
        let direccionFile = "https://api.nextniro.com/api/v1/auth/usuario";
        axios.get(direccionFile, { headers, params: { valores } })
            .then((result) => {
                user = result.data;
                this.setState({
                    first_name1: user.user.nombre,
                    last_name1: user.user.apellidos,
                    municipio: user.user.ayuntamiento
                });
            })
            .catch((error) => {
                    this.setState({
                        isLoading: false,
                      });
                  });
    };

    //////////////////////////////////////////////////////////////////////////////

    async getcalendarioList() {
        const userID = localStorage.getItem("uuidUser")
        const token = localStorage.getItem("token")
        var dataFilters = {
            'userId': userID
        };
        const valores = JSON.stringify(dataFilters)
        const headers = {
            
            'Content-Type': 'application/json',
        };
        let direccionFile = "https://api.nextniro.com/api/v1/gestion/calendarioEventos";
        await axios.get(direccionFile, { headers, params: { valores } })
            .then((result) => {
                //console.log('resultado', result)
                var events = result.data.rows;

                this.setState({
                    events: events
                });
                //return this.state.events
            })
            .catch((error) => {
                this.setState({
                    isLoading: false,
                  });
              });
    };


/////////////////////////////////////////////////////////////////////////////

    async insertcalendarioList(title, start, end, className, id, codigoIneEvento, municipioEvento, nif, empresa) {

        const token = localStorage.getItem("token")
        const user: any = localStorage.getItem("user");
        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
            //this.setState({ user: parsed });
        }
        var iduser = datosUser.userId ? datosUser.userId : ""

        var idEmpresa = datosUser.idEmpresa ? datosUser.idEmpresa : ""
        const codigoINE = datosUser.codigoINE ? datosUser.codigoINE : ""

        const ayuntamiento = datosUser.ayuntamiento ? datosUser.ayuntamiento : ""


        var calendarioDataInsert = {}

        calendarioDataInsert = {
            'title': ayuntamiento + " " + title,
            'start': start,
            'end': end,
            'className': className,
            'id': id,
            'description': "Sin descripción",
            'extendedProps': {
                'user': iduser,
                'ayuntamiento': ayuntamiento,
                'codigoIne': codigoIneEvento,
                'nif': nif,
                'empresa': empresa
            }
        };

        const headers = {
            'Content-Type': 'application/json',
        };
        let direccionFile = "https://api.nextniro.com/api/v1/gestion/calendariocreate";

        axios.post(direccionFile, calendarioDataInsert, { headers, responseType: 'json' })
            .then((result) => {

                //console.log('Actualización correcta', result)
                //console.log('Datpos del registro: ', result.data)
                //this.successAlert();
                this.setState({
                    inputDisabled: false,
                    ayuntamientoSeleccionado: false,
                    ayuntamientoDetailTotal: [],
                    toggledClearRows: !this.state.toggledClearRows,
                    saveAyuntamientoButtonDisabled: true,
                    updateAyuntamientoButtonDisabled: true,
                });
            }).catch((error) => {
                this.setState({
                    isLoading: false,
                  });
              });
    };

    async updatecalendarioList(evento) {

        const token = localStorage.getItem("token")
        const user: any = localStorage.getItem("user");
        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
            //this.setState({ user: parsed });
        }
        var iduser = datosUser.userId ? datosUser.userId : ""

        const headers = {
            'Content-Type': 'application/json',
        };
        let direccionFile = "https://api.nextniro.com/api/v1/gestion/calendarioupdate";

        axios.post(direccionFile, evento, { headers, responseType: 'json' })
            .then((result) => {

                //console.log('Actualización correcta', result)
                //console.log('Datpos del registro: ', result.data)

                this.setState({
                    inputDisabled: false,
                    ayuntamientoSeleccionado: false,
                    ayuntamientoDetailTotal: [],
                    toggledClearRows: !this.state.toggledClearRows,
                    saveAyuntamientoButtonDisabled: true,
                    updateAyuntamientoButtonDisabled: true,
                });
                //this.clearForm();
            }).catch((error) => {
                this.setState({
                    isLoading: false,
                  });
              });
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    async deletecalendarioList(borrarEvento) {

        const token = localStorage.getItem("token")
        const user: any = localStorage.getItem("user");
        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
            //this.setState({ user: parsed });
        }
        var iduser = datosUser.userId ? datosUser.userId : ""

        var calendarioDataDelete = {}

        var idEvento = borrarEvento

        calendarioDataDelete = {
                'userId': iduser,
                'id': idEvento
        };

        const headers = {
            'Content-Type': 'application/json',
        };
        let direccionFile = "https://api.nextniro.com/api/v1/gestion/calendariodelete";

        axios.post(direccionFile, calendarioDataDelete, { headers, responseType: 'json' })
            .then((result) => {

                //console.log('Actualización correcta', result)
                //console.log('Datpos del registro: ', result.data)

                this.setState({
                    inputDisabled: false,
                    ayuntamientoSeleccionado: false,
                    ayuntamientoDetailTotal: [],
                    toggledClearRows: !this.state.toggledClearRows,
                    saveAyuntamientoButtonDisabled: true,
                    updateAyuntamientoButtonDisabled: true,
                });
                //this.clearForm();
            }).catch((error) => {
                this.setState({
                    isLoading: false,
                  });
              });
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////

    changeEvent = () => {

        var idCambio = ""
        var newEvents = this.state.events.map((prop, key) => {
            if (prop.id + "" === this.state.eventId + "") {
                this.state.event.remove();
                idCambio = prop.id
                return {
                    ...prop,
                    title: this.state.eventTitle,
                    className: this.state.radios,
                    description: this.state.eventDescription
                };
            } else {
                return prop;
            }
        });

        newEvents.map((prop, key) => {
            if (prop.id + "" === idCambio + "") {
                this.updatecalendarioList(prop)
            }
        });

        this.setState({
            modalChange: false,
            events: newEvents,
            radios: "bg-info",
            eventTitle: undefined,
            eventDescription: undefined,
            eventId: undefined,
            event: undefined
        });
    };

    deleteEventSweetAlert = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="¿Estás seguro?"
                    onConfirm={() =>
                        this.setState({
                            alert: false,
                            radios: "bg-info",
                            eventTitle: undefined,
                            eventDescription: undefined,
                            eventId: undefined
                        })
                    }
                    onCancel={() => this.deleteEvent()}
                    confirmBtnCssClass="btn-secondary"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Cancelar"
                    cancelBtnText="Si, bórralo"
                    showCancel
                    btnSize=""
                >
                    Una vez realizada la acción no se podrá recuperar!
                </ReactBSAlert>
            )
        });
    };

    deleteEvent = () => {
        var newEvents = this.state.events.filter(
            prop => prop.id + "" !== this.state.eventId
        );
        
        var borrarEvento = this.state.eventId

        this.state.event.remove();

        this.deletecalendarioList(borrarEvento)        
        
        this.setState({
            alert: (
                <ReactBSAlert
                    success
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Borrado!!"
                    onConfirm={() => this.setState({ alert: null })}
                    onCancel={() => this.setState({ alert: null })}
                    confirmBtnBsStyle="primary"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    Evento borrado correctamente
                </ReactBSAlert>
            ),
            modalChange: false,
            events: newEvents,
            radios: "bg-info",
            eventTitle: undefined,
            eventDescription: undefined,
            eventId: undefined,
            event: undefined
        });
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////

    UNSAFE_componentWillReceiveProps() {
        const usuario: any = JSON.parse(JSON.stringify(this.state.UserStore['data']))
        const companyNameGlobal = usuario.company;
        const companyIdUser = usuario.companyId;
        const userGroupId = usuario.user_group_id
        const userId = usuario.id
        if (userGroupId === 1000) {
            this.setState({
                activeUser: true
            })
        };
        this.setState({
            companyNameGlobal,
            companyIdUser,
            userGroupId,
            userId
        });
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////////

    async getEmpresaLista() {

        const userID = localStorage.getItem("uuidUser")
        const token = localStorage.getItem("token")

        var dataFilters = {
            'userId': userID
        };

        const valores = JSON.stringify(dataFilters)

        const headers = {
            
            'Content-Type': 'application/json',
        };
        let direccionFile = "https://api.nextniro.com/api/v1/diccionario/empresas";

        await axios.get(direccionFile, { headers, params: { valores } })
            .then((result) => {
                //console.log('resultado', result)
                var empresas = result.data.rows;

                this.setState({
                    empresas: empresas
                });
            }).catch((error) => {
                this.setState({
                    isLoading: false,
                  });
              });
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////////

    hideAlert = () => {
        this.setState({
            alert: null
        });
    };

    confirmAlertExit = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Vuelva a iniciar sesión"
                    onConfirm={() => this.logout()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="warning"
                    confirmBtnText="Salir"
                    btnSize=""
                    focusConfirmBtn
                >
                    Se ha cerrado la sesión por seguridad. Por favor, vuelva a iniciar sesión
                </ReactBSAlert>
            )
        });
    };

    warningAlertNoData = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="No existen registros que cumplan los requisitos"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="warning"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    Revise los requisitos introducidos
                </ReactBSAlert>
            )
        });
    };

    faltaDatos = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Existen campos obligatorios sin información"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="warning"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    Revise los datos introducidos en los campos de municipio y/o distribuidora
                </ReactBSAlert>
            )
        });
    };

    /////////////////////////////////////////////////////////////////////////

    logout = async () => {
        removeToken();
        localStorage.removeItem("lastFilters");
        localStorage.removeItem("user");
        localStorage.removeItem("lastFiltersEmpre");
        localStorage.removeItem("lastFiltersMulti");
        localStorage.removeItem('lastFiltersMultiGas');
        localStorage.removeItem('lastFiltersGas');
        this.props.history.push(`/auth/login`);
    };

    /////////////////////////////////////////////////////////////////////////////////

    onChangeFieldSearch = (event) => {
        event.persist()
        var filtersData = { ...this.state.filters };
        const name = event.target.name;
        let value = event.target.value;
        const filters = this.state.filters;

        var filtersData = { ...this.state.filters };
        filters[name] = value;

        if (event.target.name === 'municipio') {
            this.setState({
                buscarButtonDisabled: false
            })
        };

        if (event.target.name === 'empresa') {
            this.setState({
                buscarButtonDisabled: false
            })
        };
        filtersData[name] = value;
        this.setState({ filters: filtersData });
    };


    onChangeModalEvento = (event) => {
        event.persist()

        const name = event.target.name;
        let value = event.target.value;

        const user: any = localStorage.getItem("user");
        var empresa = 0

        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
        }

        var municipioPDF = ""

        var municipio = datosUser.ayuntamiento ? datosUser.ayuntamiento : ""
        var codigoINE = datosUser.codigoINE ? datosUser.codigoINE : ""


        if (event.target.name === 'empresaEvento') {
            let indexEmpresa = this.state.empresas.findIndex(object =>
                object.id === value
            ); // 👉️ 1

            if (indexEmpresa !== -1) {
                empresa = this.state.empresas[indexEmpresa].valor

            };
            var nifEvento = value
            var empresaEvento = empresa

            this.setState({
                nifEvento: nifEvento,
                empresaEvento: empresaEvento,
                codigoIneEvento: codigoINE,
                municipioEvento: municipio
            });

        }
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    showFiltersToggle = () => {
        const showFilters = !this.state.showFilters;
        this.setState({ showFilters });
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////    

    getFilterIcon = () => {
        return this.state.showFilters ? "ni-bold-up" : "ni-bold-down";
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////

    clearForm = () => {
        const filters = {};
        this.setState({
            filters: {
                empresa: "",
                eventoDesde: "",
                eventoHasta: "",
                municipio: ""
            },
            inputIdDisabled: false,
            inputDisabled: false,
            buscarButtonDisabled: true,
            facturaSeleccionada: false,
            facturaDetailTotal: [],
            toggledClearRows: !this.state.toggledClearRows,
            saveClienteButtonDisabled: true,
            updateClienteButtonDisabled: true,
            createdAt: '',
            updatedAt: '',
            inputDisabledP3456: false,
            inputDisabledE456: false
        });

        this.formRef.current.reset();

    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    buscarEventos = async () => {

        this.setState({
            isLoading: true,
        })

        const token = localStorage.getItem("token")

        const user: any = localStorage.getItem("user");

        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
            //this.setState({ user: parsed });
        }

        var idEmpresa = datosUser.idEmpresa ? datosUser.idEmpresa : ""
        var idUser = datosUser.userId ? datosUser.userId : ""
        const codigoINE = datosUser.codigoINE ? datosUser.codigoINE : ""


        const now = new Date().toISOString();

        const startDate = moment(now)
            .subtract(45, "days")
            .toISOString();

        const endDate = moment(now)
            .add(90, "days")
            .toISOString();

        var dataFilters = {
            'userId': idUser,
            'idEmpresa': idEmpresa,
            'filtros': {
                'start': this.state.filters.eventoDesde ? this.state.filters.eventoDesde : startDate,
                'end': this.state.filters.eventoHasta ? this.state.filters.eventoHasta : endDate,
                'nifEvento': this.state.filters.empresa || "",
                'codigoIneEvento': codigoINE
            }
        };

        const headers = {
            'Content-Type': 'application/json',
        };

        let direccionFile = "https://api.nextniro.com/api/v1/gestion/eventosprogramacion";

        axios.post(direccionFile, dataFilters, { headers, responseType: 'json' })
            .then((result) => {
                var resultado = result.data

                var events = resultado.rows

                if (result.data.rows.length > 0) {
                    var events = result.data.rows;
                    this.setState({
                        events: events
                    });
                } else {
                    this.warningAlertNoData()
                };
            }).catch((error) => {
                this.setState({
                    isLoading: false,
                  });
              });

    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    handleChangeDateFilter = (value, formattedValue, id) => {
        var formData = { ...this.state.filters };
        const name = id;
        var valueDay = formattedValue
        if (name == 'eventoDesde') {
            this.setState({ eventoDesde: value });
            this.setState({
                buscarButtonDisabled: false,
            })
        }

        if (name == 'eventoHasta') {
            this.setState({ eventoHasta: value });
            this.setState({
                buscarButtonDisabled: false,
            })
        }

        formData[name] = value;
        this.setState({ filters: formData });
    }

    ////////////////////////////////////////////////////////////////////////////////////////

    handleClearRows = () => {
        this.setState({ toggledClearRows: !this.state.toggledClearRows })
    }

    ///////////////////////////////////////////////////////////////////////////////////////////

    handleEventClick = eventClickInfo => {

        this.setState({
            modalChange: true,
            eventId: eventClickInfo.event.id,
            eventTitle: eventClickInfo.event.title,
            eventDescription: eventClickInfo.event.extendedProps.description,
            municipioEventoDescripcion: eventClickInfo.event.extendedProps.ayuntamiento,
            comercializadoraEventoDescripcion: eventClickInfo.event.extendedProps.empresa ? eventClickInfo.event.extendedProps.empresa : "Sin empresa",
            nifEvento: eventClickInfo.event.extendedProps.nif,
            empresaEvento: eventClickInfo.event.extendedProps.empresa,
            fechaDesdeEvento: moment(eventClickInfo.event.start).format('DD-MM-YYYY'),
            fechaHastaEvento: moment(eventClickInfo.event.end).format('DD-MM-YYYY'),
            radios: "bg-info",
            event: eventClickInfo.event
        });
    };

    //////////////////////////////////////////////////////////////////////////////

    handleSelect = arg => {
        // console.log('arg : ', arg)
        const start = new Date(arg.startStr).toISOString();
        const end = moment(start)
            .add(1, "hours")
            .toISOString();

        this.setState({
            modalAdd: true,
            startDate: start,
            endDate: end,
            radios: "bg-info"
        });
    };

//////////////////////////////////////////////////////////////////////////////////

    handleSelectDrop = arg => {

        var eventId = arg.event.id
        var eventStart = arg.event.start
        var eventEnd = arg.event.end
        var event = arg.event
        var idCambio = ""
        var newEvents = this.state.events.map((prop, key) => {
            if (prop.id + "" === eventId + "") {
                //this.state.event.remove();
                idCambio = prop.id
                return {
                    ...prop,
                    start: eventStart,
                    end: eventEnd
                };
            } else {
                return prop;
            }
        });

        newEvents.map((prop, key) => {
            if (prop.id + "" === idCambio + "") {
                this.updatecalendarioList(prop)
            }
        });

        this.setState({
            events: newEvents,
            radios: "bg-info",
            eventTitle: undefined,
            eventDescription: undefined,
            eventId: undefined,
            event: undefined
        });
    };



    ///////////////////////////////////////////////////////////////////////////////////////////

    addNewEvent = () => {

        let calendarEvents = [...this.state.events];
        const token = localStorage.getItem("token")
        const user: any = localStorage.getItem("user");
        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
            //this.setState({ user: parsed });
        }
        var iduser = datosUser.userId ? datosUser.userId : ""
        let identificador = uuid()
        let title = this.state.eventTitle
        let start = this.state.startDate
        let end = this.state.endDate
        let className = this.state.radios
        let id = identificador
        let codigoIneEvento = this.state.codigoIneEvento
        let municipioEvento = this.state.municipioEvento

        let nif = this.state.nifEvento
        let empresa = this.state.empresaEvento

        calendarEvents.push({
            title: this.state.eventTitle,
            start: this.state.startDate,
            end: this.state.endDate,
            className: this.state.radios,
            id: identificador,
            description: "Sin descripción",
            extendedProps: {
                user: iduser,
                ayuntamiento: municipioEvento,
                codigoIne: codigoIneEvento,
                nif: nif,
                empresa: empresa
            }
        });

        this.setState({ events: calendarEvents });

        this.insertcalendarioList(title, start, end, className, id, codigoIneEvento, municipioEvento, nif, empresa)

        this.setState({
            modalAdd: false,
            startDate: undefined,
            endDate: undefined,
            radios: "bg-info",
            eventTitle: undefined,
            codifoIneEvento: null,
            municipioEvento: null,
            nifEvento: null,
            empresaEvento: null
        });
    };

////////////////////////////////////////////////////////////////////////////////////

    render() {

        const isLoading = this.state.isLoading;
        const styleFullWith = { "width": "100%" };
        const eventoDesde = this.state.eventoDesde
        const eventoHasta = this.state.eventoHasta

        const user: any = localStorage.getItem("user");

        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
            //this.setState({ user: parsed });
        }

        const codigoINEOrigen = datosUser.codigoINE ? datosUser.codigoINE : ""

        const ayuntamientoOrigen = datosUser.ayuntamiento ? datosUser.ayuntamiento : ""

        return (
            <>
                <Header title={'Calendario Eventos'} />
                <Container className=" mt--7" fluid>

                    <Card className="mb-4">
                        <CardHeader>
                            <Button
                                onClick={this.showFiltersToggle}
                                size="sm"
                                className="float-right"
                            >
                                <i className={"ni " + this.getFilterIcon()} />
                            </Button>
                            <h3 className="mb-0">Filtrar</h3>
                        </CardHeader>
                        <Collapse isOpen={this.state.showFilters}>
                            <CardBody>
                                <Form innerRef={this.formRef}>
                                    <Row>

                                        <Col md="3">
                                            <FormGroup>
                                                <Label className="form-control-label" for="idDistribuidora">Empresa.</Label>

                                                <Input type="select" defaultValue={'DEFAULT'} name="empresa" id="empresa" onChange={this.onChangeFieldSearch}>
                                                    <option value="">Selecciona una empresa... </option>
                                                    {this.state.empresas.map((item, key) => (
                                                        <option key={key} value={item.id}>{item.valor}</option>
                                                    ))
                                                    }
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md="2">
                                            <FormGroup>
                                                <Label className="form-control-label">Desde</Label>
                                                <DatePicker id="eventoDesde"
                                                    value={eventoDesde}
                                                    onChange={(v, f) => this.handleChangeDateFilter(v, f, "eventoDesde")}
                                                    instanceCount={1}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                />
                                            </FormGroup>
                                        </Col>


                                        <Col md="2">
                                            <FormGroup>
                                                <Label className="form-control-label">Hasta</Label>
                                                <DatePicker id="eventoHasta"
                                                    value={eventoHasta}
                                                    onChange={(v, f) => this.handleChangeDateFilter(v, f, "eventoHasta")}
                                                    instanceCount={1}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <div className="text-right">
                                        <Button onClick={this.clearForm}
                                            className="float-right ml-3 ">
                                            <i className={"ni ni-fat-remove"} /> Limpiar
                                        </Button>
                                        <Button
                                            color="primary"
                                            onClick={this.buscarEventos}
                                        >
                                            <i className={"bi bi-search"} /> Buscar
                                        </Button>
                                    </div>
                                    <Row>
                                        <Col>
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={this.props.history.goBack}
                                            >
                                                Atrás
                                            </button>
                                        </Col>
                                        <FormGroup>
                                            <Col>

                                            </Col>
                                        </FormGroup>

                                    </Row>
                                </Form>
                            </CardBody>
                        </Collapse>
                    </Card>
                    {this.state.alert}
                </Container>

                <Container fluid>
                    <Card className="card-calendar">
                        <CardBody className="p-0">
                            <FullCalendar
                                headerToolbar={{
                                    left: "prev,next today",
                                    center: "title",
                                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
                                }}
                                themeSystem={"bootstrap"}
                                plugins={[interaction, dayGridPlugin, timeGridPlugin]}
                                selectable={true}
                                editable={true}
                                locale={esLocale}
                                events={this.state.events}
                                eventClick={this.handleEventClick}
                                select={this.handleSelect}
                                displayEventEnd={true}
                                eventDrop={this.handleSelectDrop}
                            //events= {this.state.events}
                            //events={() => this.dataFecha()}
                            />
                        </CardBody>
                    </Card>
                    <Modal
                        isOpen={this.state.modalAdd}
                        toggle={() => this.setState({ modalAdd: false })}
                        className="modal-dialog-centered modal-secondary"
                    >
                        <div className="modal-body">
                            <form className="new-event--form">
                                <FormGroup>
                                    <label className="form-control-label">Titulo Evento</label>
                                    <Input
                                        className="form-control-alternative new-event--title"
                                        placeholder="Título evento"
                                        type="text"
                                        onChange={e =>
                                            this.setState({ eventTitle: e.target.value })
                                        }
                                    />
                                </FormGroup>
                                <FormGroup className="mb-0">
                                    <label className="form-control-label d-block mb-3">
                                        Color Estados
                                    </label>
                                    <ButtonGroup
                                        className="btn-group-toggle btn-group-colors event-tag"
                                        data-toggle="buttons"
                                    >
                                        <Button
                                            className={classnames("bg-info", {
                                                active: this.state.radios === "bg-info"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() => this.setState({ radios: "bg-info" })}
                                        />
                                        <Button
                                            className={classnames("bg-warning", {
                                                active: this.state.radios === "bg-warning"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() =>
                                                this.setState({ radios: "bg-warning" })
                                            }
                                        />
                                        <Button
                                            className={classnames("bg-danger", {
                                                active: this.state.radios === "bg-danger"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() => this.setState({ radios: "bg-danger" })}
                                        />
                                        <Button
                                            className={classnames("bg-success", {
                                                active: this.state.radios === "bg-success"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() =>
                                                this.setState({ radios: "bg-success" })
                                            }
                                        />
                                        <Button
                                            className={classnames("bg-default", {
                                                active: this.state.radios === "bg-default"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() =>
                                                this.setState({ radios: "bg-default" })
                                            }
                                        />
                                        <Button
                                            className={classnames("bg-primary", {
                                                active: this.state.radios === "bg-primary"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() => {
                                                this.setState({ radios: "bg-primary" });
                                            }}
                                        />
                                    </ButtonGroup>
                                </FormGroup>

                                <FormGroup>
                                    <Label className="form-control-label" for="idMunicipio">Municipio Evento</Label>
                                    <div>
                                    <FormGroup>
                                    <Label className="form-control-label" for="idMunicipio">{ayuntamientoOrigen}</Label>
                                    </FormGroup>
                                    </div>

   
                                </FormGroup>

                                <FormGroup>
                                    <Label className="form-control-label" for="idDistribuidora">Empresa Evento</Label>

                                    <Input type="select" defaultValue={'DEFAULT'} name="empresaEvento" id="empresaEvento" onChange={this.onChangeModalEvento}>
                                        <option value="">Selecciona una empresa... </option>
                                        {this.state.empresas.map((item, key) => (
                                            <option key={key} value={item.id}>{item.valor}</option>
                                        ))
                                        }
                                    </Input>
                                </FormGroup>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <Button
                                className="new-event--add"
                                color="primary"
                                type="button"
                                onClick={this.addNewEvent}
                            >
                                Crear Evento
                            </Button>
                            <Button
                                className="ml-auto"
                                color="link"
                                type="button"
                                onClick={() => this.setState({ modalAdd: false })}
                            >
                                Cerrar
                            </Button>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={this.state.modalChange}
                        toggle={() => this.setState({ modalChange: false })}
                        className="modal-dialog-centered modal-secondary"
                    >
                        <div className="modal-body">
                            <Form className="edit-event--form">
                                <FormGroup>
                                    <label className="form-control-label">Título Evento</label>
                                    <Input
                                        className="form-control-alternative edit-event--title"
                                        placeholder="Título evento"
                                        type="text"
                                        defaultValue={this.state.eventTitle}
                                        onChange={e =>
                                            this.setState({ eventTitle: e.target.value })
                                        }
                                    />
                                </FormGroup>

<Row>
                                <Col md="4">
                                    <label className="form-control-label">Comienzo</label>
                                    <Input
                                        className="form-control-alternative edit-event--title"
                                        placeholder="Comienzo evento"
                                        type="text"
                                        defaultValue={this.state.fechaDesdeEvento}
                                        disabled={true}

                                    />
                                </Col>

                                <Col md="4">
                                    <label className="form-control-label">Fin</label>
                                    <Input
                                        className="form-control-alternative edit-event--title"
                                        placeholder="Fin evento"
                                        type="text"
                                        defaultValue={this.state.fechaHastaEvento}
                                        disabled={true}
                                    />
                                </Col>
</Row>
                                <FormGroup>
                                    <label className="form-control-label d-block mb-3">
                                        Color Estados
                                    </label>
                                    <ButtonGroup
                                        className="btn-group-toggle btn-group-colors event-tag mb-0"
                                        data-toggle="buttons"
                                    >
                                        <Button
                                            className={classnames("bg-info", {
                                                active: this.state.radios === "bg-info"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() => this.setState({ radios: "bg-info" })}
                                        />
                                        <Button
                                            className={classnames("bg-warning", {
                                                active: this.state.radios === "bg-warning"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() =>
                                                this.setState({ radios: "bg-warning" })
                                            }
                                        />
                                        <Button
                                            className={classnames("bg-danger", {
                                                active: this.state.radios === "bg-danger"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() => this.setState({ radios: "bg-danger" })}
                                        />
                                        <Button
                                            className={classnames("bg-success", {
                                                active: this.state.radios === "bg-success"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() =>
                                                this.setState({ radios: "bg-success" })
                                            }
                                        />
                                        <Button
                                            className={classnames("bg-default", {
                                                active: this.state.radios === "bg-default"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() =>
                                                this.setState({ radios: "bg-default" })
                                            }
                                        />
                                        <Button
                                            className={classnames("bg-primary", {
                                                active: this.state.radios === "bg-primary"
                                            })}
                                            color=""
                                            type="button"
                                            onClick={() => {
                                                this.setState({ radios: "bg-primary" });
                                            }}
                                        />
                                    </ButtonGroup>
                                </FormGroup>
                                <FormGroup>
                                    <label className="form-control-label">Descripción</label>
                                    <Input
                                        className="form-control-alternative edit-event--description textarea-autosize"
                                        placeholder="Descripción del evento"
                                        type="textarea"
                                        defaultValue={this.state.eventDescription}
                                        onChange={e =>
                                            this.setState({ eventDescription: e.target.value })
                                        }
                                    />
                                    <i className="form-group--bar" />
                                </FormGroup>
                                <input className="edit-event--id" type="hidden" />
                                <FormGroup>
                                    <label className="form-control-label d-block mb-3">
                                        Municipio: {this.state.municipioEventoDescripcion}
                                    </label>
                                </FormGroup>
                                <FormGroup>
                                    <label className="form-control-label d-block mb-3">
                                        Comercializadora: {this.state.comercializadoraEventoDescripcion}
                                    </label>
                                </FormGroup>
                            </Form>
                        </div>
                        <div className="modal-footer">
                            <Button color="primary" onClick={this.changeEvent}>
                                Actualizar
                            </Button>
                            <Button
                                color="danger"
                                onClick={() =>
                                    this.setState({ modalChange: false }, () =>
                                        this.deleteEventSweetAlert()
                                    )
                                }
                            >
                                Borrar
                            </Button>
                            <Button
                                className="ml-auto"
                                color="link"
                                onClick={() => this.setState({ modalChange: false })}
                            >
                                Cerrar
                            </Button>
                        </div>
                    </Modal>
                </Container>

                {this.state.alert}
            </>
        );
    }
}


export default withRouter(planificacionTareas);
